<div class="truck-list-item-container" *ngIf="device">
  <a [customRouterLink]="link">
    <div class="content">
      <div class="info">
        <div
          class="img"
          *ngIf="device?.truckSeries?.images as images; else noImage"
        >
          <img
            *ngIf="images[0] as img"
            [lazyLoad]="img.url + '?width=100&height=57&padColor=fff'"
            [defaultImage]="img.url + '?width=100&height=57&padColor=fff'"
            [errorImage]="'./assets/ui/shared/error/not_found_error_image.png'"
            [alt]="img.altText"
            [title]="img.titleText || img.altText"
            src="#"
            class="device-image"
            width="100%"
            height="100%"
          />
        </div>
        <ng-template #noImage>
          <div class="img">
            <img
              [lazyLoad]="'./assets/ui/shared/error/not_found_error_image.png'"
              [defaultImage]="
                './assets/ui/shared/error/not_found_error_image.png'
              "
              [errorImage]="
                './assets/ui/shared/error/not_found_error_image.png'
              "
              alt="missing_truck"
              title="missing_truck"
              src="#"
              class="device-image"
              width="100px"
              height="100px"
            />
          </div>
        </ng-template>
        <div class="detail">
          <div class="id">{{ device.id }}</div>
          <div class="code">{{ device.equipmentDescription }}</div>
        </div>
      </div>
      <div class="customer">
        <div class="customer-label">
          {{ 'deviceList.headline.customer' | translate }}
        </div>
        <div
          class="customer-info"
          *ngIf="
            device.addressOwner &&
              device.addressOwner.companyName &&
              device.addressOwner.number;
            else noData
          "
        >
          <div class="name">{{ device.addressOwner.companyName }}</div>
          <div class="id">{{ device.addressOwner.number }}</div>
        </div>
        <ng-template #noData>
          <div class="missing-data">
            {{ 'deviceList.customer.noData' | translate }}
          </div>
        </ng-template>
      </div>
      <div class="networkpartner">
        <div class="networkpartner-info">
          <div class="name">{{ device.networkPartner.name }}</div>
          <div class="id">{{ device.networkPartner.uid }}</div>
        </div>
        <ng-template #noData>
          <div class="missing-data">
            {{ 'deviceList.customer.noData' | translate }}
          </div>
        </ng-template>
      </div>
      <div class="status">
        <div class="status-label">
          {{ 'deviceList.headline.status' | translate }}
        </div>
        <div class="label" *ngIf="device.quote as quote; else noQuote">
          <kion-status-label
            [text]="'quote.status.' + quote?.status?.toLowerCase() | translate"
            [class]="quote.status"
            theme="small"
          ></kion-status-label>
        </div>
        <ng-template #noQuote>
          <div class="label">
            <kion-status-label
              [text]="'quote.status.noData' | translate"
              theme="small"
            ></kion-status-label>
          </div>
        </ng-template>
      </div>
      <div class="changed">
        <div class="changed-label">
          {{ 'deviceList.headline.lastChange' | translate }}
        </div>
        <div
          class="changed-content"
          *ngIf="
            device.quote && device.quote.employee as employee;
            else noChange
          "
        >
          <div
            class="name"
            *ngIf="employee.firstName && employee.lastName; else noName"
          >
            {{ employee.firstName }} {{ employee.lastName }}
          </div>
          <ng-template #noName>
            <div class="name">{{ employee.uid }}</div>
          </ng-template>
          <div class="time" *ngIf="device.quote.updatedTime">
            {{ device.quote.updatedTime | date : 'dd.MM.yyyy hh:mm' }}
          </div>
        </div>
        <ng-template #noChange>
          <div class="changed-content">
            <div class="missing-data">
              {{ 'quote.noChange' | translate }}
            </div>
          </div>
        </ng-template>
      </div>
      <div class="actions">
        <kion-button
          class="detail-action"
          [isLink]="true"
          [link]="link"
          [title]="'deviceList.actions.details' | translate"
        ></kion-button>
      </div>
    </div>
  </a>
</div>
